import {combineReducers} from "redux";

import organizeBundle from "./organize-bundle";

export default combineReducers({
    organizeBundle
});